module.exports = __webpack_public_path__ + "static/media/back_button.ee6edb29.svg";